// extracted by mini-css-extract-plugin
export default {"pOItemsTable":"styles_pOItemsTable__EF6O3"};